.badge {
  display: inline-flex;
  align-items: center;
  padding-inline: 8px;
  padding-top: 3px;
  padding-bottom: 4px;
  font-size: var(--font-size-xxs);
  vertical-align: middle;
  color: var(--color-primary-blue-700);
  border: 1px solid var(--color-primary-blue-700);
  border-radius: 3px;
}
